import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "invetoryType",
})
export class InvetoryTypePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return value <= 1 || value === ""
      ? ""
      : value === 2
      ? "Intermediário"
      : "Complementar";
  }
}
